import { useState, useEffect } from 'react';
import { setStoredInversionModels } from '../lib/model-store';
import { loadPrefs } from '../lib/user-prefs';
import { loadPanelOpen, savePanelOpen } from '../lib/panel-open-state';

/**
 * Plain UI state for MapView: active tool, basemap mode, CRS/topo source and
 * the visibility flags of every panel / dialog.
 */
export function useMapPanels() {
  const [savedOpen] = useState(() => loadPanelOpen());
  const [viewMode, setViewMode] = useState(() => loadPrefs().defaultMapView);
  const [tool, setTool] = useState('select');
  const [showLayerPanel, setShowLayerPanel] = useState(true);
  const [showWorkflowPanel, setShowWorkflowPanel] = useState(true);
  const [showAgentPanel, setShowAgentPanel] = useState(true);
  const [showAnalysisPanel, setShowAnalysisPanel] = useState(false);
  const [showHeatmap, setShowHeatmap] = useState(false);
  const [showAttributeTable, setShowAttributeTable] = useState(!!savedOpen.showAttributeTable);
  const [showModelBuilder, setShowModelBuilder] = useState(false);
  const [showMapLayout, setShowMapLayout] = useState(false);
  const [coordSys, setCoordSys] = useState('EPSG:4326');
  const [showChartPanel, setShowChartPanel] = useState(!!savedOpen.showChartPanel);
  const [showStyleEditor, setShowStyleEditor] = useState(!!savedOpen.showStyleEditor);
  const [showGeoreferencing, setShowGeoreferencing] = useState(false);
  const [analysisInit, setAnalysisInit] = useState(null); // pre-load AnalysisPanel (Grid Data)
  const [showGridCombine, setShowGridCombine] = useState(false);
  const [showGridProfile, setShowGridProfile] = useState(false);
  const [showVariogram, setShowVariogram] = useState(false);
  const [showSectionView, setShowSectionView] = useState(false);
  const [showInversionPanel, setShowInversionPanel] = useState(false);
  const [showViewer3dPanel, setShowViewer3dPanel] = useState(false);
  const [inversionModels, setInversionModels] = useState([]);
  const [sectionModelId, setSectionModelId] = useState(null);
  const [showReportBuilder, setShowReportBuilder] = useState(false);
  const [reportType, setReportType] = useState(null); // summary | field | qc | anomaly | null (blank builder)
  const [pseudosection, setPseudosection] = useState(null); // { datasetId?, modelId?, model?, name? } while the panel is open

  useEffect(() => {
    savePanelOpen({ showStyleEditor, showAttributeTable, showChartPanel });
  }, [showStyleEditor, showAttributeTable, showChartPanel]);

  // Share inversion models with the 3D viewer page (fence diagrams)
  useEffect(() => {
    setStoredInversionModels(inversionModels);
  }, [inversionModels]);

  return {
    viewMode, setViewMode, tool, setTool,
    showLayerPanel, setShowLayerPanel, showWorkflowPanel, setShowWorkflowPanel, showAgentPanel, setShowAgentPanel,
    showAnalysisPanel, setShowAnalysisPanel, showHeatmap, setShowHeatmap,
    showAttributeTable, setShowAttributeTable, showModelBuilder, setShowModelBuilder,
    showMapLayout, setShowMapLayout, coordSys, setCoordSys,
    showChartPanel, setShowChartPanel, showStyleEditor, setShowStyleEditor,
    showGeoreferencing, setShowGeoreferencing, analysisInit, setAnalysisInit,
    showGridProfile, setShowGridProfile, showGridCombine, setShowGridCombine, showVariogram, setShowVariogram,
    showSectionView, setShowSectionView, showInversionPanel, setShowInversionPanel, showViewer3dPanel, setShowViewer3dPanel,
    inversionModels, setInversionModels, sectionModelId, setSectionModelId,
    showReportBuilder, setShowReportBuilder, reportType, setReportType, pseudosection, setPseudosection,
  };
}
